module.exports = __webpack_public_path__ + "static/4-f1ad5182b23d215b349fd8509e3f3f6a.jpeg";